import { Column, ColumnStore } from '@bryntum/grid';
import {$t} from "../../i18Instance";

export class RmsObjectsGridColumnRequestable extends Column {
    // Define the type for this column, used in your columns config to add this column
    static get type() {
        return 'requestableColumn';
    }

    // Override default values
    static get defaults() {
        return {
            field: 'requestable',
            align: 'center',
            cellCls: 'custom-cell-image',
            editor: false,
            htmlEncode: false,
            filterable: {
                filterField: {
                    type        : 'combo',
                    multiSelect : false,
                    editable    : false,
                    field       : 'requestable',
                    // Todo: Sollte Dynamisch geladen werden
                    items       : [
                        {text:"Ja",     value: 'true'},
                        {text:"Nein",   value: 'false'}
                    ]
                },
            },
            tooltipRenderer : ({ record }) => {
                if(record.requestable === true){
                    return "<div>" + $t('requests.grid.available') + "</div>";
                }else{
                    return "<div>" + $t('requests.grid.not-available') + "</div>";
                }
            }
        };
    }

    renderer({ record, value }) {
        if(value === true){
            return '<i class="fad fa-check fa-2x" style="color: green;"></i>';
        }else{
            return '<i class="fad fa-times fa-2x" style="color: red;"></i>';
        }
    }
};

ColumnStore.registerColumnType(RmsObjectsGridColumnRequestable);
